module.exports = __webpack_public_path__ + "static/media/neuro-account-number.551b3cbe.png";